import { navigate } from "gatsby";
import { MENU_IDS, URLS } from "./consts";
import {
  ButtonProps,
  INavigationItem,
} from "@ifgengineering/component-library";
import { IconType } from "@icon-park/react/es/all";

export const getFloatMenuItems = ({
  showTutorial,
  logoutCallback,
  onClickMyAccount,
  onClickDocuments,
  onClickIfIsa,
  isIfIsaOptionVisible,
  onClickAboutUs,
  onClickHelp,
}: {
  showTutorial: () => void;
  logoutCallback: VoidFunction;
  onClickMyAccount: VoidFunction;
  onClickDocuments: VoidFunction;
  onClickMembership: VoidFunction;
  onClickIfIsa?: VoidFunction;
  onClickAboutUs: VoidFunction;
  onClickHelp: VoidFunction;
  isIfIsaOptionVisible: boolean;
}): Array<Array<ButtonProps>> => {
  const menuFirstPart: Array<ButtonProps> = [
    {
      icon: "PlayOne",
      text: "Tutorial",
      onClick: showTutorial,
    },
    {
      icon: "Help",
      text: "Help",
      onClick: onClickHelp,
    },
    ...(onClickIfIsa && isIfIsaOptionVisible
      ? [
          {
            icon: "Funds" as IconType,
            text: "IF-ISA",
            onClick: onClickIfIsa,
          },
        ]
      : []),
    {
      icon: "Info",
      text: "About Us",
      onClick: onClickAboutUs,
    },
    {
      icon: "Setting",
      text: "Settings",
      onClick: onClickMyAccount,
    },
    {
      icon: "FilePdf" as IconType,
      text: "Documents",
      onClick: onClickDocuments,
    },
  ];

  return [
    menuFirstPart,
    [
      {
        icon: "Logout",
        text: "Logout",
        iconColor: "ERROR800",
        textColor: "ERROR800",
        onClick: logoutCallback,
      },
    ],
  ];
};

interface GetMenuItemsArgs {
  hideBankDetails: boolean;
  isWebHomepageEnabled?: boolean;
}

export const getMenuItems = ({
  hideBankDetails,
  isWebHomepageEnabled,
}: GetMenuItemsArgs): Array<INavigationItem> => {
  const navItems: Array<INavigationItem> = [
    {
      id: MENU_IDS.LIVE_DEALS,
      title: "Live Deals",
    },

    {
      id: MENU_IDS.PORTFOLIO,
      title: "My Portfolio",
    },
  ];

  navItems.splice(1, 0, {
    id: MENU_IDS.PENDING_PAYMENTS,
    title: "Payments",
  });

  navItems.push({
    id: MENU_IDS.ZAKAT,
    title: "Zakat",
  });

  if (!hideBankDetails) {
    navItems.splice(0, 0, {
      id: MENU_IDS.BANK_DETAILS,
      title: "Startup Bank Details",
    });
  }

  if (isWebHomepageEnabled) {
    navItems.unshift({
      id: MENU_IDS.HOME,
      title: "Home",
    });
  }

  return navItems;
};

export const mainMenuNavigation = (itemId: string): void => {
  const locationPerId: Record<string, string> = {
    [MENU_IDS.BANK_DETAILS]: URLS.BANK_DETAILS,
    [MENU_IDS.HOME]: URLS.HOME,
    [MENU_IDS.LIVE_DEALS]: URLS.LIVE_DEALS,
    [MENU_IDS.PORTFOLIO]: URLS.PORTFOLIO,
    [MENU_IDS.PENDING_PAYMENTS]: URLS.PENDING_PAYMENTS,
    [MENU_IDS.IDENTITY]: URLS.IDENTITY,
    [MENU_IDS.ZAKAT]: URLS.ZAKAT,
  };

  navigate(locationPerId[itemId]);
};

export const getSelectedMenuItem = (): string => {
  const idPerLocation: Record<string, string> = {
    [URLS.BANK_DETAILS]: MENU_IDS.BANK_DETAILS,
    [URLS.HOME]: MENU_IDS.HOME,
    [URLS.LIVE_DEALS]: MENU_IDS.LIVE_DEALS,
    [URLS.PORTFOLIO]: MENU_IDS.PORTFOLIO,
    [URLS.PENDING_PAYMENTS]: MENU_IDS.PENDING_PAYMENTS,
    [URLS.IDENTITY]: MENU_IDS.IDENTITY,
    [URLS.ZAKAT]: MENU_IDS.ZAKAT,
  };

  const location = window.location.pathname;

  return idPerLocation[location];
};
